module.exports = __webpack_public_path__ + "static/img/efu-general.a5fd704.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partners/efu-general.png
// module id = /q2W
// module chunks = 1